import { msg, htmlMsg, basicMsg } from "../swal_msg";
import { protectedReq } from "../../helpers/requestHelper";
import { getPromoModel } from "../../helpers/admin/promotion/promotionHelper";

// obtener todas las promociones y productos
export const getActivePromotions = async(
    setAllProducts, setBrands, setOtherPromotion, setActivePromotion
) => {
    try {
        const resp = await protectedReq('promotion/active-promos');
        const body = await resp.json();
        if (body.status) {
            const { products, brands, inactive_promos, active_promos } = body.resp;
            if (products.length < 1)
                msg('info', 'Productos no recuperados',
                'No podrá registrar promociones');
            else
                setAllProducts(products);
            setBrands(brands);
            setOtherPromotion(inactive_promos);
            setActivePromotion(active_promos);
        } else {
            if (body.msg === 'server-err')
                msg('error', 'Promociones activas',
                'Ocurrió un incidente. Intente de nuevo, por favor');
        }
    } catch (err) {
        htmlMsg('error', 'Promociones activas',
        `<p>No se pudo cargar las promociones activas</p><h6>Error: ${err}</h6>`);
    };
};

// guardar promoción
export const savePromoToBD = async(model, endpoint) => {
    try {
        const resp = await protectedReq(`promotion/${endpoint}`, model, 'POST');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'miss')
                basicMsg('Faltan datos en la promoción');
            else if (body.msg === 'promo-exists') {
                if (['2x1', '4x3', 'DescuentoProducto', 'DescuentoProducto', 'DescuentoPieza'].includes(model.promo))
                    msg('info', 'Promoción',
                    'La promoción con el producto ya existe');
                else
                    msg('info', 'Promoción',
                    'La promoción con uno de los productos ya existe');
            } else if (body.msg === 'identical-promo')
                basicMsg('Ya existe una promoción idéntica');
            else if (body.msg === 'server-err')
                msg('error', 'Promoción',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else if (body.msg === 'not-saved')
                basicMsg('Promoción no ha sido guardada');
            else
                basicMsg('Inténtelo de nuevo, por favor');
        }
        return body;
    } catch (err) {
        htmlMsg('error', 'Promoción',
        `<p>No se pudo guardar la promoción</p><h6>Error: ${err}</h6>`);
        return { status: false };
    };
};

// eliminar promoción
export const deletePromo = async(model) => {
    try {
        const resp = await protectedReq('promotion/delete', model, 'DELETE');
        const body = await resp.json();
        if (body.status)
            msg('success', 'Promoción',
            'Promoción eliminada');
        else {
            if (body.msg === 'server-err')
                msg('error', 'Promoción',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else
                msg('warning', 'Promoción',
                'Inténtelo de nuevo, por favor');
        }
        return body;
    } catch (err) {
        htmlMsg('error', 'Promoción',
        `<p>No se pudo eliminar la promoción</p><h6>Error: ${err}</h6>`);
        return { status: false };
    };
};

// actualizar promoción
export const updatePromo = async(promotion) => {
    try {
        const { status, url, model } = getPromoModel(promotion);
        if (!status) {
            basicMsg('No se reconoce el tipo de promoción');
            return { status: false };
        }
        const resp = await protectedReq(url, model, 'PUT');
        const body = await resp.json();
        if (body.status) {
            msg('success', 'Promoción',
            'Promoción actualizada');
            return { ...body, model };
        } else {
            if (body.msg === 'miss')
                basicMsg('Falta información de la promoción');
            else if (body.msg === 'server-err')
                msg('error', 'Promoción',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else
                msg('warning', 'Promoción',
                'Inténtelo de nuevo, por favor');
        }
        return body;
    } catch (err) {
        htmlMsg('error', 'Promoción',
        `<p>No se pudo actualizar la promoción</p><h6>Error: ${err}</h6>`);
        return { status: false };
    };
};